export const languageImports = {
  en: () => import("./locales/en"),
  fr: () => import("./locales/fr"),
};

export * from "./types";
